<template>
    <div class="navigation-drawer__navlist-item">

        <v-list-tile
                class="navigation-drawer__navlist-tile"
                @click="clickMenuItem"
        >
            <v-list-tile-title>
                <v-icon :class="iconColor">
                    {{ menuItem.icon }}
                </v-icon>
                <h3 class="body-2" :class="iconColor">
                    {{ menuItem.label }}
                </h3>
                <v-icon v-if="selected !== menuItem.label" :class="iconColor">
                    keyboard_arrow_down
                </v-icon>
                <v-icon v-if="selected === menuItem.label" :class="iconColor">
                    keyboard_arrow_up
                </v-icon>
            </v-list-tile-title>
        </v-list-tile>
        <!-- Begin: Was Outer -->
        <v-list dense v-if="childrenOpen & selected === menuItem.label">
            <v-list-tile v-for="child in filterChildren(menuItem.children)"
                         :key="generateUniqueHash(child)"
                         @click="clickSubMenuItem(child)"
            >
                <v-list-tile-title><h4 class='white--text'>{{ child.label }}</h4></v-list-tile-title>
            </v-list-tile>
        </v-list>
        <!-- End: Was Outer -->
    </div>
</template>


<script>
    import {mapActions, mapState, mapGetters} from 'vuex'

    import {
        VUEX_UI_NAV_CHILDREN_OPEN,
        VUEX_UI_HIDE_NAVIGATION_DRAWER,
        VUEX_UI_SHOW_NAVIGATION_DRAWER
    } from '@/store/constants/ui'

    export default {
        name: 'navigation-drawer-item',

        data: () => ({
            id: Date.now(),
            isMenuHovered: false,
            myActivator: null,
            openState: false,
            timer: null,
        }),

        props: [
            'menuItem',
            'isDrawerOpen',
        ],

        computed: {
            ...mapGetters({
                currentUserHasPerm: 'currentUserHasPerm'
            }),

            hasChildren() {
                return (this.menuItem.children && this.menuItem.children.length)
            },
            ...mapState({
                childrenOpen: state => state.ui.mobileChild.childrenOpen,
                selected: state => state.ui.mobileChild.selected,
                currentUser: state => state.auth.currentUser
            }),
            iconColor() {
                let iconClass = (this.selected == this.menuItem.label) ? 'white--text' : 'grey--text text--darken-2'
                return iconClass
            }
        },

        mounted() {

        },

        watch: {},

        methods: {
            ...mapActions({
                setChildren: VUEX_UI_NAV_CHILDREN_OPEN,
                closeDrawer: VUEX_UI_HIDE_NAVIGATION_DRAWER,
            }),

            clickMenuItem() {
                this.setChildren(this.menuItem.label)
            },

            clickSubMenuItem(child) {
                this.$router.push({name: child.routeName})
                this.closeDrawer()
            },

            hasPermission(childItem) {
                let userPerms = this.currentUser.permissions
                if (childItem !== 'Requests') return true
                return userPerms.includes(SILA_PERMISSION_JOBS_JOB_CREATE)
            },

            filterChildren(children) {
                const childItems = children.filter(child => {
                    const permission = child.permission
                    if (permission && permission !== '' && this.currentUserHasPerm(window[permission]) === false) {
                        return false
                    }

                    if (child.label === "Calendar") {
                        return false
                    }
                    if (!this.hasPermission(child.label) && child.label === 'Requests') {
                        return false
                    }
                    return true
                })
                return childItems
            },

        },
    }
</script>

